/**
 * @fileoverview AR-924 — Fixed drawer footer once something was submitted: nudge + "Assess now".
 */

import { Button, Group, Text } from '@mantine/core'
import { IconClipboardText } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'

const ICON_SIZE = 16
/** Figma: the hint wraps on two lines at ~260px. */
const HINT_MAX_WIDTH = 280

interface AssessNowFooterProps {
  readonly studentFirstName: string
  readonly onAssess: () => void
}

export function AssessNowFooter({ studentFirstName, onAssess }: AssessNowFooterProps) {
  const { t } = useTranslation()
  return (
    <Group position="apart" noWrap align="center">
      <Text size="xs" color="dimmed" sx={{ maxWidth: HINT_MAX_WIDTH }}>
        {t('task_tracker.teacher_upload.assess_next_hint', { name: studentFirstName })}
      </Text>
      <Button leftIcon={<IconClipboardText size={ICON_SIZE} />} onClick={onAssess}>
        {t('task_tracker.teacher_upload.assess_now')}
      </Button>
    </Group>
  )
}
